import { Injectable } from '@angular/core';
import { Rest } from '../../../../rest/rest_client';
import { Rest_logistics } from './rest_client_logistics';
import { EntityService } from '../../../../rest/entity.service';
import { JQueryHTTPClient } from '../../../../rest/JQueryHTTPClient';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AuthenticationService } from '../../../../core/services/authentication/authentication.service';
import { NotificationsService, Severity } from '../../../../services/notifications-service/notifications.service';

@Injectable({
  providedIn: 'root'
})
export class ExcelMappingService extends EntityService<Rest_logistics.ExcelMapping> {
	client: Rest.RestApplicationClient;

	constructor(
		private jquery: JQueryHTTPClient,
		private http: HttpClient,
		private auth: AuthenticationService,
		private notificationsService: NotificationsService
	) {
		super();
		this.client_task = new Rest_logistics.RestApplicationClient(jquery);
	}

	create(arg0: any): Rest.RestResponse<Rest_logistics.ExcelMapping> {
		return this.client_task.ExcelMapping_create(arg0);
	}

	find(arg0: string): Rest.RestResponse<Rest_logistics.ExcelMapping> {
		return this.client_task.ExcelMapping_find(arg0);
	}

}
